// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filters-list[data-v-282fb390] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.header-content[data-v-282fb390] {\n  flex-wrap: wrap;\n}\n.color-white[data-v-282fb390] {\n  color: #fff;\n  margin-top: 1.5rem;\n}\n@media (max-width: 678px) {\n.filters-list[data-v-282fb390] {\n    flex-direction: column;\n}\n}\n", ""]);
// Exports
module.exports = exports;
